import { apiPatch } from "../client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IExamConfig, IExamConfigSubject } from "./getExamConfigList";

// 시험 설정 수정 요청 인터페이스
export interface IUpdateExamConfigRequest {
  subjects: IExamConfigSubject[];
}

/**
 * 시험 설정 수정 API 함수
 * @param id 수정할 시험 설정의 ID
 * @param data 수정할 데이터
 * @returns API 응답
 */
export const apiUpdateExamConfig = async (
  id: string,
  data: IUpdateExamConfigRequest
) => {
  const response = await apiPatch<IExamConfig>(`/exam_configs/${id}`, data);
  return response.data;
};

/**
 * 시험 설정 수정 React Query 훅
 * @param id 수정할 시험 설정의 ID
 * @returns 뮤테이션 객체
 */
export const useUpdateExamConfig = (id: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IUpdateExamConfigRequest) =>
      apiUpdateExamConfig(id, data),
    onSuccess: () => {
      // 시험 설정 목록과 특정 시험 설정 데이터 무효화
      queryClient.invalidateQueries({ queryKey: ["examConfigs"] });
      queryClient.invalidateQueries({ queryKey: ["examConfig", id] });
    },
  });
};

export default useUpdateExamConfig;
